import { useRef, useState } from 'react';
import './App.css';
import {GoogleMap, Marker, useLoadScript, Autocomplete, DirectionsRenderer} from '@react-google-maps/api';

const libraries = ['places']
const mapContainerStyle = {
  width: '100%',
  height: '100%'
}
const center = {
  // lat: 46.231337985292946,
  lat: 46.2313,
  // lng: 6.073415524456243
  lng: 6.0734
}

function App() {
  const [open, setOpen] = useState(false)
  const [coords, setCoords] = useState({})
  const [distance, setDistance] = useState(0)
  const [map, setMap] = useState(/** @type google.maps.Map */ (null))
  const [directionsResponse, setDirectionsResponse] = useState(null)
  const [duration, setDuration] = useState('')

  const originRef = useRef()
  const destinationRef = useRef()

  const handleMap = () => {
    setOpen(!open)
  }

  const {isLoaded, loadError} = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries
  })

  if (loadError) {
    return <div>Error loading maps</div>
  }
  
  if (!isLoaded) {
    return <div>Loading maps...</div>
  }

  const handleLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const {latitude, longitude, accuracy} = position.coords
        console.log('lat: ' + latitude)
        console.log('lng: ' + longitude)
        console.log('accuracy: ' + accuracy)
        setCoords({lat:latitude, lng:longitude})
        setDistance(accuracy)
        originRef.current.value = `lat: ${latitude.toFixed(4)}, lng: ${longitude.toFixed(4)}`
      })
    }
  }

  async function calculateRoute() {
    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService()
    // const originPlace = originRef.current.getPlace()
    // const destinationPlace = destinationRef.current.getPlace()
    // console.log(`center: ${center}`)
    // console.log(`destinationRef.current.value: ${destinationRef.current.value}`)
    // console.log(`originPlace: ${originPlace}`)
    // console.log(`destinationPlace: ${destinationPlace}`)
    // console.log(`originPlace.geometry.location.lat(): ${originPlace.geometry.location.lat()}`)
    // console.log(`destinationPlace.geometry.location.lng(): ${destinationPlace.geometry.location.lng()}`)
    const results = await directionsService.route({
      origin: center,
      destination: destinationRef.current.value,
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING
    })
    setDirectionsResponse(results)
    setDistance(results.routes[0].legs[0].distance.text)
    setDuration(results.routes[0].legs[0].duration.text)
  }

  function clearRoutes() {
    setDirectionsResponse(null)
    setDistance('')
    setDuration('')
    destinationRef.current.value = ''
  }

  return (
    <div className="App">
      <div className="SearchArea">
        <div style={{display:'flex'}}>
          <input type='text' placeholder='Votre adresse' ref={originRef} disabled />
          {/* <Autocomplete onLoad={(autocomplete) => (destinationRef.current = autocomplete)}> */}
          <Autocomplete>
            <input type='text' placeholder='Entrer une adresse' ref={destinationRef} />
          </Autocomplete>
        </div>
        <div>
          <span>Distance: {distance} </span>
          <span>Duration: {duration}</span>
        </div>
        <div className='InsideSearchArea'>
          <button onClick={handleLocation}>Get location</button>
          <button onClick={handleMap}>Show map</button>
          <button onClick={calculateRoute}>Itinéraire</button>
          <button onClick={clearRoutes}>Effacer</button>
        </div>
      </div>
      {open && (
        <div className='Maps'>
          <div className='Overlay'>
            <button onClick={handleMap}>Close map</button>
            <span>Accuracy: {distance} mètres</span>
            <button onClick={() => map.panTo(center)}>Recentrer</button>
          </div>
          {isLoaded && <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={coords}
            zoom={10}
            onLoad={(map) => setMap(map)}
          >
            <Marker 
              position={coords}
            />
            {directionsResponse && <DirectionsRenderer directions={directionsResponse} />}
          </GoogleMap>}
        </div>
      )}
    </div>
  );
}

export default App;
